import {NOTIFICATIONS_SET_PROPS} from 'actions/notifications';
import {propsReducer} from "utils/stateUtils";

const DEFAULT_STATE = {
};

export default propsReducer(NOTIFICATIONS_SET_PROPS, DEFAULT_STATE);
